import { Component, OnInit, Input } from "@angular/core";
import { ICheckboxSettings } from "./checkbox.model";

@Component({
    selector: "dodo-checkbox",
    templateUrl: "./checkbox.component.html",
    styleUrls: ["./checkbox.component.scss"],
    standalone: false
})
export class CheckboxComponent implements OnInit {
	@Input() settings: ICheckboxSettings;
	@Input() isOn: Boolean;
	@Input() checked: Boolean;
	@Input() disabled: Boolean;

	constructor() {}

	ngOnInit() {}

	onChange(event: any) {
		console.log("event: ", event);
	}

	computedLabel() {
		// todo: change so that the label used is the one coming from the settings
		if (
			this.settings &&
			this.settings.label &&
			this.settings.label.text &&
			this.settings.label.text.on &&
			this.settings.label.text.off
		) {
			return this.checked || this.isOn
				? this.settings.label.text.on
				: this.settings.label.text.off;
		} else if (
			this.settings &&
			this.settings.label &&
			this.settings.label.text &&
			this.settings.label.text.default
		) {
			return this.settings.label.text.default;
		}
	}
}
